import { motion } from "motion/react";
import { cn } from "@/lib/utils";

type InputErrorProps = {
  message?: string;
  className?: string;
};

export default function InputError({
  message,
  className = "",
  ...props
}: InputErrorProps) {
  if (!message) {
    return null;
  }

  return (
    <motion.p
      {...props}
      animate={{ opacity: 1, height: "auto" }}
      className={cn("text-destructive-foreground text-sm", className)}
      initial={{ opacity: 0, height: 0 }}
      transition={{ duration: 0.2 }}
    >
      {message}
    </motion.p>
  );
}
